import type { UserManager } from 'oidc-client-ts';
import { useEffect, useRef, useState } from 'react';
import { useNavigate } from 'react-router';

/** Regreso de Keycloak: canjea el código por los tokens y vuelve a donde estaba el usuario. */
export function Callback({ gestor }: { gestor: UserManager }) {
  const navegar = useNavigate();
  const [error, setError] = useState<string | null>(null);
  const hecho = useRef(false);
  useEffect(() => {
    if (hecho.current) return;
    hecho.current = true;
    gestor
      .signinRedirectCallback()
      .then((u) => {
        const volver = (u.state as { volver?: string } | undefined)?.volver;
        void navegar(volver && volver !== '/callback' ? volver : '/', { replace: true });
      })
      .catch((e: Error) => setError(e.message));
  }, [gestor, navegar]);
  return (
    <div className="centro">
      {error ? (
        <div className="entrada">
          <h1>No se pudo iniciar sesión</h1>
          <p className="error">{error}</p>
          <a className="boton" href="/">
            Volver a intentar
          </a>
        </div>
      ) : (
        <p className="subtitulo">Entrando…</p>
      )}
    </div>
  );
}
